import { z } from 'zod';
export const importBoundsSchema = z.tuple([z.number().min(-180).max(180), z.number().min(-90).max(90), z.number().min(-180).max(180), z.number().min(-90).max(90)]).refine(([west, south, east, north]) => west < east && south < north);
export type ImportBounds = z.infer<typeof importBoundsSchema>;
export const importCatalogSchema = z.object({ datasets: z.array(z.object({ name: z.string().min(1).max(500), url: z.string().url().max(4096) })).min(1).max(500) });
const column = z.number().int().nonnegative().nullable();
export const urlLayerSourceSchema = z.object({
  url: z.string().max(4096).url().refine(value => value.startsWith('https://')),
  format: z.enum(['geojson', 'csv', 'xlsx', 'kml']),
  bbox: importBoundsSchema.optional(),
  attribution: z.string().max(4000).optional(),
  lastRefreshedAt: z.string().datetime(),
  sheet: z.object({ name: z.string(), headers: z.array(z.string()), mapping: z.object({ latitude: column, longitude: column, wkt: column, label: column, color: column, group: column, order: column }).strict() }).strict().optional(),
}).strict();
export type UrlLayerSource = z.infer<typeof urlLayerSourceSchema>;
